import React, {useEffect, useState} from 'react'
import {Link, withRouter} from "react-router-dom"
import {Breadcrumbs, Typography} from "@material-ui/core";
import HomeIcon from '@material-ui/icons/Home';
import {withStyles} from "@material-ui/core/styles";
import BILSearchInput from "../../components/BILSearchInput/BILSearchInput";
import FilterSearchInput from "../../components/FilterSearchInput/FilterSearchInput";
import ApiCatalogCard from "../../components/ApiCatalogCard/ApiCatalogCard";
import FilterSearchChip from "../../components/FilterSearchChip/FilterSearchChip";
import '../../../assets/style/catalog.scss'
import {saveApiTabSelection} from "../../stores/ApiTabSelectionParam/ApiTabSelectionParamActions";
import {connect} from "react-redux";
import {saveApiSelection} from "../../stores/ApiSelectionParam/ApiSelectionParamActions";
import {getStaticResource} from "../../../api/developer";
import BILLoader from "../../components/BILLoader/BILLoader";

const styles = theme => ({
    tab: {
        color: '#702F8A',
        '&:hover': {
            color: 'black'
        },
        '&:focus': {
            boxShadow: 'none',
            outline: 'none'
        },
        fontWeight: 300,
        minWidth: '90px',
        width: '90px'
    },
    indicator: {
        backgroundColor: '#702F8A'
    },
    link: {
        display: 'flex',
        color: '#008577',
        '&:hover': {
            color: 'grey'
        },
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    breadcrumbs: {
        marginTop: "55px",
        marginLeft: "40px"
    },
    breadcrumbsText: {
        fontSize: "15px",
        color: "#000000"
    }
});

const Catalog = (props) => {

    useEffect(() => {
        getStaticResource("/documentation/api-catalog-config.json")
            .then(async (res) => await setApis(res.data))
            .then(async (res) => await getStaticResource("/documentation/api-catalog-filter-chips-config.json")
                .then(async (res) => setApiFilters(res.data)))
            .then(async () => await setIsLoading(false));
    }, []);

    const {classes, saveApiSelection, saveApiTabSelection} = props;
    const [searchValue, setSearchValue] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [apis, setApis] = useState({});
    const [apiFilters, setApiFilters] = useState({});
    const [chipData, setChipData] = React.useState([]);

    return (
        <div className="root-all bg-white">
            <div className={"breadcrumbs-container"}>
                <Breadcrumbs className={classes.breadcrumbs} aria-label="breadcrumb">
                    <Link to={"/"} color="inherit" className={classes.link}>
                        <HomeIcon className={classes.icon}/>
                        <Typography className={classes.breadcrumbsText}>Home</Typography>
                    </Link>
                    <Typography className={classes.breadcrumbsText}>API Catalog</Typography>
                </Breadcrumbs>

                <span className={"api-catalog-title"}>
                      API Catalog
                  </span>

                <div className={"api-catalog-input-search-container-parent"}>
                    <div className={"api-catalog-input-search-container"}>
                        <BILSearchInput
                            onChange={setSearchValue}
                            value={searchValue}
                            onClear={() => setSearchValue('')}
                            placeholder={"Search"}
                        />
                    </div>
                </div>
            </div>
            {
                isLoading ?
                    <div className="intl-spinner-container">
                        <BILLoader/>
                    </div>
                    :
                    <div className={"api-catalog-content-parent-container"}>
                        <FilterSearchInput apiFilters={apiFilters} chipData={chipData} setChipData={setChipData}/>
                        <div className={"api-catalog-content-right-container"}>
                            <FilterSearchChip apiFilters={apiFilters} chipData={chipData} setChipData={setChipData}/>
                            <ApiCatalogCard apis={apis} value={searchValue} chipData={chipData}
                                            saveApiSelection={saveApiSelection}
                                            saveApiTabSelection={saveApiTabSelection}/>
                        </div>
                    </div>
            }
        </div>
    );
}

//// JS REDUX
const mapStateToProps = (state) => ({
    apiSelection: state.apiSelectionParam.apiSelection,
    apiTabSelection: state.apiTabSelectionParam.apiTabSelection,
});

const mapDispatchToProps = {
    saveApiSelection,
    saveApiTabSelection
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(Catalog)))

